import { Divider } from 'antd';
import styled from 'styled-components';

const FullDivider = styled(Divider)`
  margin: 16px -16px;
  width: unset;
`;

export default FullDivider;
